import { Link } from "react-router-dom"

function Nav() {
    return <nav className="app__header__links">
        <Link to="/#about">About</Link>
        <Link to="/contact">Contact</Link>
    </nav>
}

export default Nav;